import { ScreenDimensions } from 'src/hooks/useScreenDimensions'

export const getEntityDimensions = (
  screenDimensions: ScreenDimensions,
): ScreenDimensions => ({
  width: screenDimensions.height * 0.2,
  height: screenDimensions.height * 0.2,
})
